import { useMemo } from 'react';
import { IOffer } from '../models';

export function getRelevantOffer(offers: IOffer[]): IOffer {
  const offerTypes = offers?.map((offer) => offer.offerType) || [];
  
  if (offerTypes.includes('FREE')) {
    return offers.find(
      (offer) => offer.offerType === 'FREE'
    ) as IOffer;
  } else if (offerTypes.includes('SUBSCRIPTION')) {
    return offers.find(
      (offer) => offer.offerType === 'SUBSCRIPTION'
    ) as IOffer;
  } else if (offerTypes.includes('PURCHASE')) {
    return offers.find(
      (offer) => offer.offerType === 'PURCHASE'
    ) as IOffer;
  } else if (!offerTypes.length) {
    // should we throw an error here?
    return offers?.[0] || {};
  } else {
    // should we throw an error here?
    return offers?.[0] || {};
  }
}

export function useOffer(offers: IOffer[]): IOffer {
  const offer = useMemo(() => getRelevantOffer(offers), [offers]);
  return offer;
}
